
<template>
  <div class="home" style="display:flex;flex-direction:column;">
    <ThemePicker style="display:none"/>
    <Header />
    <div class="home_content">
       <router-view  />
      <!-- <keep-alive>
            <router-view  v-if="$route.meta.keepAlive"  />
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive" /> -->
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from '../components/header/header'
import Footer from '../components/footer/footer'
import ThemePicker from "../components/theme-picker/theme-picker"
export default {
  name: 'home',
  components: {
    Header,
    Footer,
    ThemePicker
  }
}
</script>
<style lang="scss" scoped>
    .home{
      min-height: 100%; 
      .home_content{
        margin-top: 56px;
        flex: 1;
      }
    }
</style>

